import {connect} from "react-redux";
import {RoleComponent} from "./RoleComponent";

const mapStateToProps = (state) => {
    const {user, changePasswordForm, profile} = state;
    return {
        user,
        changePasswordForm,
        profile
    };
};

export const Roles = connect(mapStateToProps, {

})(RoleComponent);
